import * as React from 'react';
import Container from '@mui/material/Container';
import GlobalStyles from "@mui/material/GlobalStyles/GlobalStyles";
import Button from "@mui/material/Button/Button";
import Typography from "@mui/material/Typography/Typography";
import {useLocation, useNavigate, useParams} from 'react-router-dom';
import firebase from "../../firebase/firebase";
import Stack from "@mui/material/Stack/Stack";
import FormControlLabel from "@mui/material/FormControlLabel/FormControlLabel";
import FormControl from "@mui/material/FormControl/FormControl";
import RadioGroup from "@mui/material/RadioGroup/RadioGroup";
import Radio from "@mui/material/Radio/Radio";
import AlertDialog from "../../components/AlertDialog"
import ScrollToTop from '../../utils/scrollTop';
import PostActivity from "../../helpers/post-activity";
import {useContext} from "react";
import {AuthUserContext} from "../../providers/AuthProvider";



export default function PaymentEscrowDetails(){
  const { profile} = useContext(AuthUserContext);

  const location = useLocation()
  const navigator = useNavigate()
  const { contractId } = useParams();
  const { projectId, amount } = location.state;
  const [open, setOpen] = React.useState(false);

  const [value, setAmount] = React.useState();
  const updateContractAmount = async () => {
    if(value==="Yes"){
      const contractRef = firebase.firestore().collection('contracts').doc(contractId);
      await contractRef.update({
        haveYouMadeThePayment: value
      })
      PostActivity({
        text: `You have made a payment of $${amount} into the Taost escrow account`,
        uid: profile.uid,
        createdBy:profile?.uid
      }).then()
      navigator(`/investor/payments/bank-details/${contractId}`, {state: {
          haveYouMadeThePayment: value,
          amount,
          projectId
        }});
    }else{
      setOpen(true)
    }
  }
  return(

    <React.Fragment>
      <ScrollToTop/>
      <GlobalStyles styles={{ ul: { margin: 0, padding: 0, listStyle: 'none' } }} />
      {open && <AlertDialog open={true} title={"Before you move forward…"} message={"You will need to make the payment now in order to move forward"} btn_Orange_Text={"Go Back"}/>}
      {/* Hero unit */}
      {/*<TopBar showBar={true}/>*/}
      <Container maxWidth="fullWidth" sx={{backgroundColor: '#E3E8F0', paddingY: 8,  mb: 8, textAlign:'left'}}>
        <Container maxWidth="lg">
          <Typography variant={'h4'} sx={{pl: 2}} color={'primary'}>
            PAYMENT
          </Typography>
        </Container>
      </Container>
      <Container maxWidth="md" sx={{textAlign:'left' }}>
        <Stack direction={'column'} spacing={5}>
          <Typography variant={'h5'} color={'primary'} >
            Escrow Bank details
          </Typography>
          <Stack direction={'row'} spacing={10}>
            <Typography variant={'body1'} sx={{fontWeight: 600, width:200}}>
              Bank Name:
            </Typography>

            <Typography variant={'body1'} >
              XXXXXXXXXXXXXXXX
            </Typography>

          </Stack>
          <Stack direction={'row'} spacing={10}>
            <Typography variant={'body1'} sx={{fontWeight: 600, width:200}}>
              Account title:
            </Typography>

            <Typography variant={'body1'} >
              XXXXXXXXXXXXXXXX
            </Typography>

          </Stack>
          <Stack direction={'row'} spacing={10}>
            <Typography variant={'body1'} sx={{fontWeight: 600, width:200}}>
              Account number:
            </Typography>

            <Typography variant={'body1'} >
              XXXXXXXXXXXXXXXX
            </Typography>

          </Stack>

          <Typography variant={'h5'} color={'primary'} >
            Have You Made The Payment?
          </Typography>

          <FormControl>
            <RadioGroup
              row
              spacing={5}
              onChange={(e) => setAmount(e.target.value)}
            >
              <FormControlLabel value="Yes" control={<Radio />} label="Yes, I Have Made the Transaction" />
              <FormControlLabel value="No" control={<Radio />} label="No, I Haven’t" />
            </RadioGroup>
          </FormControl>
        </Stack>
        <Stack direction={'row'} justifyContent="center"
               alignItems="center" sx={{mt:10,mb:8}}>
          <Button variant={'contained'}  sx={{px: 7}} onClick={updateContractAmount} disabled={!value}>
            Next
          </Button>
        </Stack>
      </Container>
    </React.Fragment>
  )
}